<template>
  <div>
    <h2 v-if="fileListData.length > 0">Список загруженных файлов</h2>
    <el-table
      v-if="fileListData.length > 0"
      :data="fileListData"
      stripe
      style="width: 100%"
      max-height="400px"
    >
      <el-table-column prop="date" label="" width="50">
        <template slot-scope="scope">
          <img :src="scope.row.link" width="24" />
        </template>
      </el-table-column>
      <el-table-column v-if="!isMobile" prop="name" label="Стутус" width="80">
        <template slot-scope="scope">
          <i
            v-if="scope.row.is_approve == 1"
            class="el-icon-circle-check font20 green"
          />
          <i
            v-if="scope.row.is_approve == 3"
            class="el-icon-circle-close font20 red"
          />
          <i
            v-if="scope.row.is_approve == 0"
            class="el-icon-warning font20 orange"
          />
        </template>
      </el-table-column>
      <el-table-column v-if="!isMobile" prop="address" label="Имя">
        <template slot-scope="scope">
          {{ scope.row.name || `Файл № ${scope.row.id}` }}
        </template>
      </el-table-column>
      <el-table-column prop="address" label="Действие" width="120">
        <template slot-scope="scope">
          <el-link
            v-if="isImage(scope.row)"
            type="primary"
            icon="el-icon-view"
            @click="showImage(scope.row.link)"
          >
            Смотреть
          </el-link>
          <el-link
            v-if="isPdf(scope.row)"
            type="primary"
            icon="el-icon-view"
            @click="downLoadPdf(scope.row.link)"
          >
            Скачать
          </el-link>
        </template>
      </el-table-column>

      <el-table-column prop="address" label="Действие" width="100">
        <template slot-scope="scope">
          <el-link
            type="danger"
            icon="el-icon-delete"
            @click="deleteOne(scope.row.link)"
          >
            Удалить
          </el-link>
        </template>
      </el-table-column>
    </el-table>
    <br />
    <p v-if="fileListData.length > 0">
      <el-link type="primary" icon="el-icon-download" @click="getFilesZip">
        Скачать одним архивом
</el-link
      >&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
      <el-link type="danger" icon="el-icon-delete-solid" @click="deleteAll">
        Удалить все
      </el-link>
      <!--      <a-->
      <!--        v-if="!approved"-->
      <!--        class="set-approvement"-->
      <!--        @click="() => $emit('setApprovement')"-->
      <!--        >Сделать актуальным</a-->
      <!--      >-->
      <!--      <span v-else class="approved">Уже актуальный</span>-->
    </p>
    <el-image-viewer
      v-if="showImages"
      :z-index="9999"
      :url-list="imagesList"
      :on-close="closeViewer"
    />
  </div>
</template>

<script>
import ElImageViewer from 'element-ui/packages/image/src/image-viewer'

const pdf = require('@/assets/img/pdf.jpg')
const image = require('@/assets/img/image.jpg')

const fileTypeIcon = {
  pdf,
  image,
}

export default {
  name: 'ListUploadedFiles',
  components: { ElImageViewer },
  props: {
    fileList: {
      type: Array,
      default: () => [],
    },
    typeDocument: {
      type: String,
      default: '',
    },
    approved: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      showImages: false,
      imagesList: [],
      fileListData: [],
    }
  },
  computed: {
    isImage() {
      return data => this.typeFile(data) === 'image'
    },
    isPdf() {
      return data => this.typeFile(data) === 'pdf'
    },
  },
  watch: {
    fileList: {
      immediate: true,
      handler(val) {
        this.fileListData = val
      },
    },
  },
  methods: {
    deleteOne(data) {
      this.$emit('deleteOne', data)
    },
    deleteAll() {
      this.$emit('deleteAll')
    },
    typeFileIcon(item) {
      let type = this.typeFile(item)

      return fileTypeIcon[type]
    },
    downLoadPdf(file) {
      window.open(file, '_blank')
    },
    getFilesZip() {
      this.$emit('getZip')
    },
    closeViewer() {
      this.showImages = false
      this.$emit('closeShowImage')
    },
    showImage(url) {
      let res = this.fileListData.filter(
        data => this.typeFile(data) === 'image',
      )

      this.imagesList = []
      let ret = []
      let currentKey = 0

      for (let key in res) {
        if (res[key].link === url) {
          currentKey = key
        }
        ret.push(res[key].link)
      }
      this.imagesList = this.imagesList.concat(
        ret.slice(currentKey, ret.length),
        ret.slice(0, currentKey),
      )
      this.showImages = true
      this.$emit('openShowImage')

      return ret
    },
    typeFile(item) {
      let ext = item.link.substr(item.link.lastIndexOf('.') + 1)

      if (ext === 'png' || ext === 'jpg' || ext === 'jpeg') {
        return 'image'
      }
      if (ext === 'pdf') {
        return 'pdf'
      }
    },
  },
}
</script>

<style scoped>
.set-approvement {
  color: #3498db;
  font-weight: 500;
  font-size: 12px;
  text-decoration: underline;
  margin-left: 15px;
  cursor: pointer;
}
.approved {
  margin-left: 15px;
  font-weight: 500;
  font-size: 12px;
  color: #67c23a;
}

.font20 {
  font-size: 25px !important;
  font-weight: bold;
}

.green {
  color: green;
}

.orange {
  color: orange;
}

.red {
  color: red;
}

.vmidle {
  vertical-align: center;
}

h2,
.el-dialog__title {
  font-family: 'Rubik Medium', sans-serif;
}

.frubik {
  font-family: Rubik, sans-serif !important;
  padding-top: 6px;
}

[class*='el-col-'] {
  display: block !important;
}

.el-link {
  font-family: 'Rubik Medium', sans-serif !important;
}

.el-table__body td,
.el-table__body td {
  font-family: 'Rubik Medium', sans-serif !important;
  padding: 0px 0 !important;
}
</style>
